module.exports = __webpack_public_path__ + "img/cultura2.fe6ee049.png";